import { useI18n } from '../../context/useI18n';
import ImageSourceField from './ImageSourceField';
import GymLogoUpload from '../gym/GymLogoUpload';
import PhoneField from '../ui/PhoneField';

/** Marca mínima para gimnasios: nombre comercial, logo, colores y WhatsApp (sin marketing avanzado). */
export default function GymMinimalBrandingFields({
  formData,
  setFormData,
  showBrandName = true,
  showLoginHero = false,
  gymId = null,
}) {
  const { t } = useI18n();

  const onChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="space-y-4 pt-2 border-t border-slate-200">
      <h5 className="text-sm font-semibold text-stone-800">
        {t('gym.mi_marca.title', 'Mi Marca')}
      </h5>
      {showBrandName ? (
        <label className="block text-sm">
          <span className="font-semibold">{t('gym.brand_commercial_name', 'Nombre comercial')}</span>
          <input
            className="input mt-1 w-full"
            name="brand_name"
            value={formData.brand_name || ''}
            onChange={onChange}
            placeholder={formData.nombre || ''}
          />
        </label>
      ) : null}
      {gymId ? (
        <div>
          <span className="font-semibold text-sm block mb-1">{t('gyms.logo_url', 'Logo')}</span>
          <GymLogoUpload
            gymId={gymId}
            currentUrl={formData.logo_url || ''}
            onUploaded={(url) => setFormData((prev) => ({ ...prev, logo_url: url }))}
          />
          <p className="text-xs text-stone-500 mt-1">
            {t('gym.mi_marca.logo_tab_hint', 'También se usa como icono de la pestaña del navegador.')}
          </p>
        </div>
      ) : (
        <ImageSourceField
          label={t('gyms.logo_url', 'Logo')}
          value={formData.logo_url || ''}
          onChange={(url) => setFormData((prev) => ({ ...prev, logo_url: url }))}
          alt="Logo"
        />
      )}
      <div className="grid sm:grid-cols-2 gap-3">
        <label className="block text-sm">
          <span className="font-semibold">{t('gyms.primary_color', 'Color principal')}</span>
          <input
            type="color"
            className="input mt-1 w-full h-10"
            name="primary_color"
            value={formData.primary_color || '#2563eb'}
            onChange={onChange}
          />
        </label>
        <label className="block text-sm">
          <span className="font-semibold">{t('gyms.secondary_color', 'Color secundario')}</span>
          <input
            type="color"
            className="input mt-1 w-full h-10"
            name="secondary_color"
            value={formData.secondary_color || '#10b981'}
            onChange={onChange}
          />
        </label>
      </div>
      <PhoneField
        label={t('gyms.support_whatsapp', 'WhatsApp de soporte')}
        value={formData.support_whatsapp || ''}
        onChange={(v) => setFormData((prev) => ({ ...prev, support_whatsapp: v }))}
        inputClassName="input mt-1 w-full"
        className="block text-sm"
        labelClassName="font-semibold"
        placeholder="300 123 4567"
      />

      {showLoginHero ? (
        <div className="space-y-3 pt-3 border-t border-slate-200">
          <h5 className="text-sm font-semibold text-stone-800">
            {t('gym.mi_marca.login_hero_title', 'Mensaje del login')}
          </h5>
          <p className="text-xs text-stone-500">
            {t(
              'gym.mi_marca.login_hero_hint',
              'Se muestra en /gym/tu-slug y en /gym/tu-slug/login. Vacío = mensaje de plataforma.',
            )}
          </p>
          <label className="block text-sm">
            <span className="font-semibold">{t('gym.mi_marca.login_line_white', 'Línea 1 (blanca)')}</span>
            <input
              className="input mt-1 w-full"
              name="login_line_white"
              value={formData.login_line_white || ''}
              onChange={onChange}
              placeholder="ENTRENAMIENTO EN VIVO"
              maxLength={80}
            />
          </label>
          <label className="block text-sm">
            <span className="font-semibold">{t('gym.mi_marca.login_line_yellow_1', 'Línea 2 (acento)')}</span>
            <input
              className="input mt-1 w-full"
              name="login_line_yellow_1"
              value={formData.login_line_yellow_1 || ''}
              onChange={onChange}
              placeholder="CON LOS MEJORES PROFESIONALES."
              maxLength={80}
            />
          </label>
          <label className="block text-sm">
            <span className="font-semibold">{t('gym.mi_marca.login_line_yellow_2', 'Línea 3 (acento)')}</span>
            <input
              className="input mt-1 w-full"
              name="login_line_yellow_2"
              value={formData.login_line_yellow_2 || ''}
              onChange={onChange}
              placeholder="TE ESPERAMOS EN CLASES"
              maxLength={80}
            />
          </label>
          <label className="block text-sm">
            <span className="font-semibold">{t('gym.mi_marca.login_subtitle', 'Subtítulo')}</span>
            <textarea
              className="input mt-1 w-full min-h-[72px]"
              name="welcome_message"
              value={formData.welcome_message || ''}
              onChange={onChange}
              placeholder="La energía de un gimnasio real, en la comodidad de tu casa."
              maxLength={280}
            />
          </label>
        </div>
      ) : null}
    </div>
  );
}
